import {
  SET_TRAINER_DATA,
  SET_TRAINER_ATTRIBUTE,
  SET_TRAINERS_DATA,
  SET_TRAINER_COUNT,
  SET_TRAINER_CALENDAR_SCHEDULE,
  SET_ADD_PROGRAM_MODAL_OPEN,
} from '../../actions/types/types';

const initState = {
  trainer: {},
  trainers: [],
  trainerCount: 0,
  trainerAttribute: [],
  allTrainers:[],
  trainerCalendarSchedule:undefined,
  addProgramModalopen:false,
};

const TrainerReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_TRAINER_DATA:
      return {
        ...state,
        trainer: action.payload.data,
      };
    case SET_TRAINER_COUNT:
      return {
        ...state,
        trainerCount: action.payload.data,
      };
    case SET_TRAINER_ATTRIBUTE:
      return {
        ...state,
        trainerAttribute: action.payload.data,
      };
    case SET_TRAINERS_DATA:
      return {
        ...state,
        trainers: action.payload.data,
      };
    case 'SET_ALL_TRAINERS_DATA':
      return {
        ...state,
        allTrainers: action.payload.data,
      };  
    case SET_TRAINER_CALENDAR_SCHEDULE:
      return {
        ...state,
        trainerCalendarSchedule: action.payload.data,
      };  
    case SET_ADD_PROGRAM_MODAL_OPEN:
      return {
        ...state,
        addProgramModalopen: action.payload.data,
      };  
    default:
      return { ...state };
  }
};

export default TrainerReducer;
